import getDomainPathReduxUtil from '../get-domain-path'

export default function getDefaultDomainListPathReduxUtil (instance) {
  return `${getDomainPathReduxUtil(instance)}.all`
}
